const types = {
	//Get Template name
	GET_TECHNICIAN_START: "GET_TECHNICIAN_START",
	GET_TECHNICIAN_SUCCESS: "GET_TECHNICIAN_SUCCESS",
	GET_TECHNICIAN_ERROR: "GET_TECHNICIAN_ERROR",
	GET_TECHNICIAN_RESET: "GET_TECHNICIAN_RESET",

	//Create Template name
	CREATE_TECHNICIAN_START: "CREATE_TECHNICIAN_START",
	CREATE_TECHNICIAN_SUCCESS: "CREATE_TECHNICIAN_SUCCESS",
	CREATE_TECHNICIAN_ERROR: "CREATE_TECHNICIAN_ERROR",
	CREATE_TECHNICIAN_RESET: "CREATE_TECHNICIAN_RESET",

	//delete Template name
	DELETE_TECHNICIAN_START: "DELETE_TECHNICIAN_START",
	DELETE_TECHNICIAN_SUCCESS: "DELETE_TECHNICIAN_SUCCESS",
	DELETE_TECHNICIAN_ERROR: "DELETE_TECHNICIAN_ERROR",
	DELETE_TECHNICIAN_RESET: "DELETE_TECHNICIAN_RESET",

	//update Template name
	UPDATE_TECHNICIAN_START: "UPDATE_TECHNICIAN_START",
	UPDATE_TECHNICIAN_SUCCESS: "UPDATE_TECHNICIAN_SUCCESS",
	UPDATE_TECHNICIAN_ERROR: "UPDATE_TECHNICIAN_ERROR",
	UPDATE_TECHNICIAN_RESET: "UPDATE_TECHNICIAN_RESET",

	//single item  name
	SINGLE_TECHNICIAN_START: "SINGLE_TECHNICIAN_START",
	SINGLE_TECHNICIAN_SUCCESS: "SINGLE_TECHNICIAN_SUCCESS",
	SINGLE_TECHNICIAN_ERROR: "SINGLE_TECHNICIAN_ERROR",
	SINGLE_TECHNICIAN_RESET: "SINGLE_TECHNICIAN_RESET",
};

export default types;
